





















import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import CustomTokenForm from '@/views/reports/forms/flow/views/conditions/custom-token-form.vue';

@Component({
  components: {
    CustomTokenForm
  }
})
export default class CustomToken extends Vue {
  @Prop()
  conditions: any;

  tokenModels: any[] = [];

  mounted() {
    if (this.conditions.customToken) {
      this.tokenModels = this.conditions.customToken.map((e: any) => {
        let includeEmpty = false;
        return {
          selected: e.values,
          parameter: e.parameter,
          predicate: e.predicate,
          include_empty: includeEmpty,
          predicateList: [
            { label: this.t('Equals'), value: 'EQUALS'},
            { label: this.t('Contains'), value: 'CONTAINS'},
            { label: this.t('Not equal'), value: 'NOT_EQUALS'},
            { label: this.t('Not contain'), value: 'NOT_CONTAINS'},
          ],
          values: [ this.emptyValue ],
        };
      });
    } else {
      this.add();
    }
  }

  @Watch('tokenModels', {
    deep: true
  })
  onTokenModelsChanged(value: any[], oldValue: any[]) {
    let result = this.tokenModels.map(e => {
      return {
        values: e.selected,
        parameter: e.parameter,
        predicate: e.predicate
      };
    });

    this.$set(this.conditions, 'customToken', result);
  }

  add() {
    this.tokenModels.push({
      predicateList: [
        { label: this.t('Equals'), value: 'EQUALS'},
        { label: this.t('Contains'), value: 'CONTAINS'},
        { label: this.t('Not equal'), value: 'NOT_EQUALS'},
        { label: this.t('Not contain'), value: 'NOT_CONTAINS'},
      ],
      predicate: 'EQUALS',
      parameter: '',
      selected: [],
      values: [ this.emptyValue ],
      include_empty: false
    });
  }

  remove(model: any) {
    if (this.tokenModels.length == 1) return this.$emit('close');

    this.tokenModels.splice(this.tokenModels.indexOf(model), 1);
  }

  get emptyValue() {
    return {
      text: `[${this.t('Empty Value')}]`,
      value: ''
    };
  }
}
